import { render, staticRenderFns } from "./BullProposal.vue?vue&type=template&id=10b24efa&scoped=true&"
import script from "./BullProposal.vue?vue&type=script&lang=js&"
export * from "./BullProposal.vue?vue&type=script&lang=js&"
import style0 from "./BullProposal.vue?vue&type=style&index=0&id=10b24efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b24efa",
  null
  
)

export default component.exports